export const loadImage = async (url: string) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = url;
    img.onload = resolve;
    img.onerror = (error) => {
      console.log('Ошибка чтения ресурса', url, error);
      resolve(true);
    };
  });
};

export const preloadImage = (src: string) => {
  const link = document.createElement('link');
  link.setAttribute('rel', 'preload');
  link.setAttribute('as', 'image');
  link.setAttribute('href', src);
  document.head.appendChild(link);
};
